// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../img/bg.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.letrero {
    color: #a2d1e0;
    font-size: 34px;
    text-decoration: none;
  }

  .letrero2 {
    color: #545454;;
    font-size: 34px;
    text-decoration: none;
  }

  a {
    text-decoration: none;
  }

  body {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) 0 0 repeat-x #ffffff;
  }

  .container2 {
    margin: 0 auto;
    padding: 0;
  }
  
  /* Evitar espaciado adicional en la fila */
  .container2 .row {
    margin: 0;
    padding: 0;
    display: flex;
    justify-content: center; /* Centra el contenido horizontalmente */
  }
  
  /* Estilo para el encabezado */
  .sub-header h1 {
    display: flex;
    justify-content: center; /* Centra horizontalmente el contenido */
    align-items: center;     /* Centra verticalmente el contenido */
    margin: 20px;
    padding: 0;
    font-size: 2rem;
  }
  
  /* Elimina cualquier espacio entre los h2 y los mantiene en la misma línea */
  .letrero, .letrero2 {
    margin: 0;
    padding: 0;
    font-size: 4rem; /* Tamaño de fuente grande */
    font-weight: bold;
    display: inline-block; /* Asegura que ambos estén en la misma línea sin espacio */
  }
  
  /* Media Query para pantallas grandes */
  @media (min-width: 768px) {
    .sub-header h1 {
      font-size: 3rem;
    }
    .nav-link {
        margin-top: 25px;
        margin-right: 20px;
    }
    .navbar-nav .nav-link:hover::before,
    .navbar-nav .nav-link.active::before {
    content: "";  /* Necesario para crear la línea */
    position: absolute;
    top: -47px;  /* La línea estará en la parte superior */
    left: 0;
    width: 100%;  /* La línea ocupará todo el ancho del botón */
    height: 10px;  /* Altura de la línea */
    background-color: #a2d1e0;;  /* Color azul de la línea */
    }
  }

  .navbar-nav .nav-link {
    color: #000;  /* Color inicial del texto (negro) */
    text-decoration: none;  /* Quita el subrayado del enlace */
    padding: 10px 15px;  /* Espaciado alrededor del texto */
    position: relative;  /* Necesario para la línea superior */
    
}
  
  /* Efecto cuando se pasa el ratón por encima del botón (hover) */
  .navbar-nav .nav-link:hover {
    color: #a2d1e0;  /* Cambia el color del texto a azul */
  }
  
  /* Efecto cuando el botón está activo (seleccionado) */
  .navbar-nav .nav-link.active {
    color: #a2d1e0;;  /* Cambia el color del texto a azul cuando está activo */
  }
  
  /* Línea azul encima de los botones en hover o cuando está activo */

  .linea {
    width: 92%;         /* Ancho de la línea (80%) */
    height: 5.0px;        /* Altura de la línea */
    background-color: #a2d1e0; /* Color de la línea */
    margin: 10px auto;  /* Margen superior e inferior, centrado horizontalmente */
  }

  @media (max-width: 767px) {
    
    .nav-link {
        display: flex;
        flex-direction: column;
        justify-content: center;
        text-align: center;
        align-items: center;
    }
}

.centrar {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/css/Header.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,eAAe;IACf,qBAAqB;EACvB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,wEAAmD;EACrD;;EAEA;IACE,cAAc;IACd,UAAU;EACZ;;EAEA,0CAA0C;EAC1C;IACE,SAAS;IACT,UAAU;IACV,aAAa;IACb,uBAAuB,EAAE,wCAAwC;EACnE;;EAEA,8BAA8B;EAC9B;IACE,aAAa;IACb,uBAAuB,EAAE,wCAAwC;IACjE,mBAAmB,MAAM,sCAAsC;IAC/D,YAAY;IACZ,UAAU;IACV,eAAe;EACjB;;EAEA,4EAA4E;EAC5E;IACE,SAAS;IACT,UAAU;IACV,eAAe,EAAE,4BAA4B;IAC7C,iBAAiB;IACjB,qBAAqB,EAAE,0DAA0D;EACnF;;EAEA,uCAAuC;EACvC;IACE;MACE,eAAe;IACjB;IACA;QACI,gBAAgB;QAChB,kBAAkB;IACtB;IACA;;IAEA,WAAW,GAAG,kCAAkC;IAChD,kBAAkB;IAClB,UAAU,GAAG,yCAAyC;IACtD,OAAO;IACP,WAAW,GAAG,6CAA6C;IAC3D,YAAY,GAAG,uBAAuB;IACtC,yBAAyB,IAAI,2BAA2B;IACxD;EACF;;EAEA;IACE,WAAW,GAAG,oCAAoC;IAClD,qBAAqB,GAAG,kCAAkC;IAC1D,kBAAkB,GAAG,kCAAkC;IACvD,kBAAkB,GAAG,qCAAqC;;AAE9D;;EAEE,gEAAgE;EAChE;IACE,cAAc,GAAG,qCAAqC;EACxD;;EAEA,sDAAsD;EACtD;IACE,cAAc,IAAI,wDAAwD;EAC5E;;EAEA,mEAAmE;;EAEnE;IACE,UAAU,UAAU,4BAA4B;IAChD,aAAa,SAAS,uBAAuB;IAC7C,yBAAyB,EAAE,sBAAsB;IACjD,iBAAiB,GAAG,yDAAyD;EAC/E;;EAEA;;IAEE;QACI,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,kBAAkB;QAClB,mBAAmB;IACvB;AACJ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB","sourcesContent":[".letrero {\r\n    color: #a2d1e0;\r\n    font-size: 34px;\r\n    text-decoration: none;\r\n  }\r\n\r\n  .letrero2 {\r\n    color: #545454;;\r\n    font-size: 34px;\r\n    text-decoration: none;\r\n  }\r\n\r\n  a {\r\n    text-decoration: none;\r\n  }\r\n\r\n  body {\r\n    background: url(../img/bg.jpg) 0 0 repeat-x #ffffff;\r\n  }\r\n\r\n  .container2 {\r\n    margin: 0 auto;\r\n    padding: 0;\r\n  }\r\n  \r\n  /* Evitar espaciado adicional en la fila */\r\n  .container2 .row {\r\n    margin: 0;\r\n    padding: 0;\r\n    display: flex;\r\n    justify-content: center; /* Centra el contenido horizontalmente */\r\n  }\r\n  \r\n  /* Estilo para el encabezado */\r\n  .sub-header h1 {\r\n    display: flex;\r\n    justify-content: center; /* Centra horizontalmente el contenido */\r\n    align-items: center;     /* Centra verticalmente el contenido */\r\n    margin: 20px;\r\n    padding: 0;\r\n    font-size: 2rem;\r\n  }\r\n  \r\n  /* Elimina cualquier espacio entre los h2 y los mantiene en la misma línea */\r\n  .letrero, .letrero2 {\r\n    margin: 0;\r\n    padding: 0;\r\n    font-size: 4rem; /* Tamaño de fuente grande */\r\n    font-weight: bold;\r\n    display: inline-block; /* Asegura que ambos estén en la misma línea sin espacio */\r\n  }\r\n  \r\n  /* Media Query para pantallas grandes */\r\n  @media (min-width: 768px) {\r\n    .sub-header h1 {\r\n      font-size: 3rem;\r\n    }\r\n    .nav-link {\r\n        margin-top: 25px;\r\n        margin-right: 20px;\r\n    }\r\n    .navbar-nav .nav-link:hover::before,\r\n    .navbar-nav .nav-link.active::before {\r\n    content: \"\";  /* Necesario para crear la línea */\r\n    position: absolute;\r\n    top: -47px;  /* La línea estará en la parte superior */\r\n    left: 0;\r\n    width: 100%;  /* La línea ocupará todo el ancho del botón */\r\n    height: 10px;  /* Altura de la línea */\r\n    background-color: #a2d1e0;;  /* Color azul de la línea */\r\n    }\r\n  }\r\n\r\n  .navbar-nav .nav-link {\r\n    color: #000;  /* Color inicial del texto (negro) */\r\n    text-decoration: none;  /* Quita el subrayado del enlace */\r\n    padding: 10px 15px;  /* Espaciado alrededor del texto */\r\n    position: relative;  /* Necesario para la línea superior */\r\n    \r\n}\r\n  \r\n  /* Efecto cuando se pasa el ratón por encima del botón (hover) */\r\n  .navbar-nav .nav-link:hover {\r\n    color: #a2d1e0;  /* Cambia el color del texto a azul */\r\n  }\r\n  \r\n  /* Efecto cuando el botón está activo (seleccionado) */\r\n  .navbar-nav .nav-link.active {\r\n    color: #a2d1e0;;  /* Cambia el color del texto a azul cuando está activo */\r\n  }\r\n  \r\n  /* Línea azul encima de los botones en hover o cuando está activo */\r\n\r\n  .linea {\r\n    width: 92%;         /* Ancho de la línea (80%) */\r\n    height: 5.0px;        /* Altura de la línea */\r\n    background-color: #a2d1e0; /* Color de la línea */\r\n    margin: 10px auto;  /* Margen superior e inferior, centrado horizontalmente */\r\n  }\r\n\r\n  @media (max-width: 767px) {\r\n    \r\n    .nav-link {\r\n        display: flex;\r\n        flex-direction: column;\r\n        justify-content: center;\r\n        text-align: center;\r\n        align-items: center;\r\n    }\r\n}\r\n\r\n.centrar {\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: center;\r\n  align-items: center;\r\n  text-align: center;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
